import { editBook } from "../actionCreator";

const updateBookData = (bookData) => {
    return async (dispatch) => {
        const res = await fetch(`http://localhost:9000/books/${bookData.id}`, {
            method: 'PATCH',
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(bookData)
        })

        const book = await res.json();
        
        dispatch(editBook(book))
    }
}

export default updateBookData;